import React from 'react';
import { useMapEngine } from './MapEngineContext';

const STYLES = [
  { id: 'mapbox://styles/mapbox/empty-v9',    label: 'CAD'      },
  { id: 'mapbox://styles/mapbox/satellite-v9', label: 'Satélite' },
] as const;

const MapModeToolbar: React.FC = () => {
  const { baseStyle, setBaseStyle } = useMapEngine();

  return (
    <div className="absolute top-3 left-[68px] z-20 flex gap-1">
      {STYLES.map((s) => {
        const active = baseStyle === s.id;
        return (
          <button
            key={s.id}
            onClick={() => setBaseStyle(s.id)}
            className={`rounded-lg px-3 py-1.5 text-[11px] font-semibold shadow-lg transition-all ${
              active
                ? 'bg-[#F26430] text-white'
                : 'bg-[#13131a]/90 text-[var(--text-secondary)] border border-[#2a2a30] hover:text-white backdrop-blur-sm'
            }`}
          >
            {s.label}
          </button>
        );
      })}
    </div>
  );
};

export default MapModeToolbar;
